import { useAppState } from '../useAppState';

export const useWaitersCache = () => {
  const { waitersCache } = useAppState();

  return waitersCache;
};
